import { SocketProvider } from '@swtorbit/shared-react-hooks';
import { Galaxy } from '@swtorbit/ui/react';
import { AuthProvider, useAuthContext } from './contexts/AuthContext';
import { GameProvider } from './contexts/GameContext';
import { GameTypeProvider } from './contexts/GameTypeProvider';
import { ContentLibraryProviders } from './components/content-library';
import { DiscordProvider } from './contexts/DiscordContext';
import { DiscordCallback } from './components/DiscordCallback';
import { LoginContainer } from './components/auth';
import { DashboardLayout } from './components/dashboard';
import { API_URL } from './config';

function AppContent() {
  const { isAuthenticated } = useAuthContext();

  if (!isAuthenticated) {
    return <LoginContainer />;
  }

  return (
    <DiscordProvider isAuthenticated={isAuthenticated}>
      <GameProvider isAuthenticated={isAuthenticated}>
        <ContentLibraryProviders>
          <GameTypeProvider>
            <DashboardLayout />
          </GameTypeProvider>
        </ContentLibraryProviders>
      </GameProvider>
    </DiscordProvider>
  );
}

function App() {
  // Discord OAuth callback short-circuits the rest of the app
  if (window.location.pathname === '/auth/discord/callback') {
    return <DiscordCallback />;
  }

  return (
    <SocketProvider url={API_URL}>
      <AuthProvider>
        <AppContent />
        <Galaxy />
      </AuthProvider>
    </SocketProvider>
  );
}

export default App;
